import { define } from "remount";
import DiscussionLiveSidebar from "./discussion_live_sidebar";
import DiscussionUploadModal from "./discussion_upload_modal";
import TickerTape from "./components/TickerTape";

define({
	"discussion-live-sidebar": DiscussionLiveSidebar,
	"discussion-upload-modal": DiscussionUploadModal,
	"ticker-tape": TickerTape
});
